<template lang="pug">
.container.forbidden
  h2.ui.center.aligned.icon.header
    i.lock.icon
    .content 无访问权限
  a.themed.text(@click='$router.back()') 返回
</template>

<script>
export default {
  name: 'forbidden',
}
</script>



// WEBPACK FOOTER //
// Forbidden.vue?8348c654